import React, { useState, useRef, useEffect } from "react";
import { BASE_URL_MEDIA } from "../../../../api/Constants";

function ImageZoomInOut({
  imageUrl,
  setShowImage,
  images,
  selectedImgaeeIndex,
}) {
  const [scale, setScale] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(selectedImgaeeIndex);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const imageRef = useRef(null);

  const handleZoomIn = () => {
    setScale((scale) => scale + 0.1);
  };

  const handleZoomOut = () => {
    setScale((scale) => scale - 0.1);
  };

  useEffect(() => {
    const image = imageRef.current;
    let isDragging = false;
    let prevPosition = { x: 0, y: 0 };

    const handleMouseDown = (e) => {
      isDragging = true;
      prevPosition = { x: e.clientX, y: e.clientY };
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - prevPosition.x;
      const deltaY = e.clientY - prevPosition.y;
      prevPosition = { x: e.clientX, y: e.clientY };
      setPosition((position) => ({
        x: position.x + deltaX,
        y: position.y + deltaY,
      }));
    };

    const handleMouseUp = () => {
      isDragging = false;
    };

    image?.addEventListener("mousedown", handleMouseDown);
    image?.addEventListener("mousemove", handleMouseMove);
    image?.addEventListener("mouseup", handleMouseUp);

    return () => {
      image?.removeEventListener("mousedown", handleMouseDown);
      image?.removeEventListener("mousemove", handleMouseMove);
      image?.removeEventListener("mouseup", handleMouseUp);
    };
  }, [imageRef, scale]);

  return (
    <div className="show-progress-selected-image">
      <div
        style={{
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {currentIndex + 1 < images.length && (
          <div
            className="next-img"
            onClick={() => {
              setCurrentIndex(currentIndex + 1);
              setScale(1);
              setPosition({ x: 0, y: 0 });
            }}
          >
            <i class="fa fa-angle-right"></i>
          </div>
        )}
        {currentIndex - 1 > -1 && (
          <div
            className="prev-img"
            onClick={() => {
              setCurrentIndex(currentIndex - 1);
              setScale(1);
              setPosition({ x: 0, y: 0 });
            }}
          >
            <i class="fa fa-angle-left"></i>
          </div>
        )}
        <div className="preogeress-zoom-btn-container">
          <div className="progress-imga-zoom-icon">
            <i
              className="fa fa-search-plus zoom-icons"
              onClick={handleZoomIn}
            ></i>

            <i
              className="fa fa-search-minus zoom-icons"
              onClick={handleZoomOut}
            ></i>

            <i
              className="fa fa fa-times"
              onClick={() => setShowImage(false)}
            ></i>
          </div>
        </div>

        <img
          className="progress-zoom-image-postions"
          ref={imageRef}
          src={
            currentIndex > -1 && currentIndex < images.length
              ? `${BASE_URL_MEDIA}/storage/assets/uploads/${images[currentIndex].image}`
              : imageUrl
          }
          alt=""
          style={{
            width: "30vw",
            height: "auto",
            transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
            cursor: "move",
          }}
          draggable={false}
        />
      </div>
    </div>
  );
}
const GalleryModal = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState("");
  const [showImage, setShowImage] = useState(false);
  const [selectedImgaeeIndex, setseletedImageIndex] = useState(null);

  return (
    <div className="progress-image-gallery" id="my-gallery">
      <div className="image-gallery-progress">
        {images.map((image, index) => (
          <div
            className="gallery-image-box"
            onClick={() => {
              if (showImage && selectedImgaeeIndex === index) {
                setSelectedImage("");
                setShowImage(false);
                setseletedImageIndex(null);
              } else {
                setSelectedImage(image.image);
                setShowImage(true);
                setseletedImageIndex(index);
              }
            }}
          >
            <img
              src={`${BASE_URL_MEDIA}/storage/assets/uploads/${image.image}`}
              alt="image"
              width={300}
            />
            <i className="fa fa-search-plus zoom-icon"></i>
          </div>
        ))}
      </div>
      <div className="selected-image">
        {showImage && (
          <ImageZoomInOut
            imageUrl={`${BASE_URL_MEDIA}/storage/assets/uploads/${selectedImage}`}
            setShowImage={setShowImage}
            images={images}
            selectedImgaeeIndex={selectedImgaeeIndex}
          ></ImageZoomInOut>
        )}
      </div>
    </div>
  );
};

export default GalleryModal;
